import React from 'react'
import AboutPage from './AboutPage'

const MainAbout = () => {
  return (
    // Apply overflowX: 'hidden' to the top-level container
    // This helps prevent horizontal scrollbar issues, especially with AOS animations
    <div style={{ overflowX: 'hidden' }}>
      <AboutPage/>
    </div>
  )
}

export default MainAbout